import { Skeleton } from '@/shared/components/ui/skeleton';

export function UserAuthorizationWorkspacePendingState() {
  return (
    <div className="flex min-h-svh min-w-0 flex-col bg-background" aria-busy="true">
      <header className="flex shrink-0 items-center gap-3 border-b p-3 sm:p-4">
        <Skeleton className="h-8 w-20" />
        <Skeleton className="size-10 rounded-full" />
        <div className="space-y-2">
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-3 w-56" />
        </div>
      </header>
      <div className="flex flex-1 flex-col gap-4 p-4 sm:p-6">
        <div className="flex items-center justify-between gap-4">
          <div className="space-y-2">
            <Skeleton className="h-4 w-48" />
            <Skeleton className="h-3 w-72" />
          </div>
          <Skeleton className="h-8 w-32" />
        </div>
        <Skeleton className="min-h-56 w-full flex-1" />
      </div>
    </div>
  );
}
